import { render } from "./SessionTrackingModal.vue?vue&type=template&id=36fb7f3c"
import script from "./SessionTrackingModal.vue?vue&type=script&lang=js"
export * from "./SessionTrackingModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__